<template>
  <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
      :disabled="disabled"
    >

    <template v-slot:activator="{ props }">
      <div v-bind="props" >
        <slot></slot>
      </div>
    </template>

    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <span>
          {{$t('routes.node.FCPImport')}}
        </span>

        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text  v-if="pods.length == 0">
        <div class="bg-error" data-cy="">
          {{$t("routes.node.FCPNoItems")}}
        </div>
      </v-card-text>

      <v-card-text>
        <div v-if="errorMessage" class="bg-error"> {{ errorMessage }} </div>
      </v-card-text>

      <v-card-text>
        <li v-for="pod in this.pods" v-bind:key="pod.id">
          {{ pod.name }}
        </li>
      </v-card-text>

        <v-card-text class="text-center">
          <v-progress-circular v-if="loading"
              indeterminate
              color="primary"
              :aria-label="$t('common.loading')">
          </v-progress-circular>
        </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="flat" elevation="0" @click="addToFCP">{{$t('common.import')}}</v-btn>
        <v-btn variant="text" @click="cancel">{{$t('common.cancel')}}</v-btn>
      </v-card-actions>
    </v-card>


  </v-dialog>
</template>

<script>
import Helper from '@/components/helper';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  mixins: [DialogActionKeys, DialogModel],
  name: "FinalCutProDialog",
  props: {
    pods: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data: function() {
    return {
      loading: false,
      errorMessage: "",
    }
  },
  mounted: function() {
  },
  methods: {
    addToFCP: function() {
        this.errorMessage = '';

        const urls = [];
        const names = [];
        const durations = [];
        const hasAudios = [];
        const hasVideos = [];
        const audioRates = [];
        const audioChanels = [];
        const frameDurations = [];
        const widths = [];
        const heights = [];
        const isNoVideoNoAudio = [];
        for (const pod of this.pods) {
          const url = pod.asset.raw[0].url;
          const name = pod.name;
          const duration = pod.asset.raw[0].duration ?? 0;
          const hasAudio = pod.asset.raw[0].audiobitrate ? 1 : 0;
          const hasVideo = pod.asset.raw[0].bitrate ? 1 : 0;
          const audioRate = pod.asset.raw[0].audiobitrate;
          const audioChanel = pod.asset.raw[0].audiochanels;
          let frameDuration = null;
          let widthHeight;
          let width = null;
          let height = null;
          if (hasVideo) {
            frameDuration = pod.asset.raw[0].framerate ? (pod.asset.raw[0].duration / pod.asset.raw[0].framerate) : 1;

            if (pod.asset.raw[0].resolution && pod.asset.raw[0].resolution.indexOf('x') >= 0) {
              widthHeight = pod.asset.raw[0].resolution.split('x');
              width = widthHeight[0];
              height = widthHeight[1];
            }
          }
          const noVideoNoAudio = !hasAudio && !hasVideo;
          urls.push(url);
          names.push(name);
          durations.push(duration);
          hasAudios.push(hasAudio);
          hasVideos.push(hasVideo);
          audioRates.push(audioRate);
          audioChanels.push(audioChanel);
          frameDurations.push(frameDuration);
          widths.push(width);
          heights.push(height);
          isNoVideoNoAudio.push(noVideoNoAudio);
        }

        const namesSet = Array.from(new Set(names));
        if (namesSet.length < names.length) {
          this.errorMessage = this.$t('routes.node.FCPDownloadNotAllowed');
          return;
        }

        const downloadObject = JSON.stringify({action: "chooseFolder",
                                            names: names,
                                            downloadURLs: urls,
                                            durations: durations,
                                            hasAudios: hasAudios,
                                            hasVideos: hasVideos,
                                            audioRates: audioRates,
                                            audioChanels: audioChanels,
                                            frameDurations: frameDurations,
                                            widths: widths,
                                            heights: heights,
                                            isNoVideoNoAudio: isNoVideoNoAudio,
                                            });
        Helper.invokeFCPMessageHandler('fcpextension', downloadObject);
        this.dialog = false;
    },

    cancel: function() {
      this.dialog = false;
      this.errorMessage = "";
      this.loading = false;
    },
  },
  computed: {

  }
}
</script>

<style>

</style>
